import type { CinematicSequence } from '../../../renderer/src/cinematic-sequence';
import { evaluateAuthoredCameraTrack, resolveCameraKeyframes } from '../domain/camera-keyframes';

/** Restrict immediate camera updates to rotation edits at the same composition position. */
export function interactiveRotation(previous: CinematicSequence | undefined, next: CinematicSequence | undefined,
  progress: number, duration: number, automatic: number, cameraPlatform?: string): number | undefined {
  if (cameraPlatform === 'chase') return undefined;
  if (!next?.cameraTracks?.rotation.length) return undefined;
  const withoutRotation = (sequence: CinematicSequence | undefined) => JSON.stringify({
    waypoints: sequence?.waypoints ?? [], targetLock: sequence?.cameraTracks?.targetLock ?? true,
    tilt: sequence?.cameraTracks?.tilt ?? [], altitude: sequence?.cameraTracks?.altitude ?? [],
    lens: sequence?.cameraTracks?.lens ?? [], roll: sequence?.cameraTracks?.roll ?? [],
  });
  if (withoutRotation(previous) !== withoutRotation(next)
    || JSON.stringify(previous?.cameraTracks?.rotation ?? []) === JSON.stringify(next.cameraTracks.rotation)) return undefined;
  const tracks = resolveCameraKeyframes(next.cameraTracks, duration);
  return evaluateAuthoredCameraTrack(tracks, 'rotation', progress * duration, () => automatic);
}
